import React from 'react';
import { Baby, Trophy } from 'lucide-react';

export default function StudentCard({ student, onViewProgress, onLoginAsChild }) {
  return (
    <div className="student-card">
      <div className="avatar-circle">
        <Baby size={40} color="#6366f1" />
      </div>
      <h3>{student.username}</h3>
      {student.grade?.name && (
        <p className="grade-badge">{student.grade.name}</p>
      )}
      <div className="student-stats">
        <span><Trophy size={16} /> {student.points || 0} Points</span>
      </div>
      <button
        type="button"
        className="btn primary-btns"
        onClick={() => onViewProgress(student.id)}
      >
        View Progress
      </button>
      <button
        type="button"
        className="btn accent-btns"
        onClick={() => onLoginAsChild(student)}
      >
        Login as {student.username}
      </button>
    </div>
  );
}